import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

// Trabajo pendiente del usuario (backend: `agent/pending-work/`). Devuelve el objeto directo
// ({items}), sin envoltorio {status} — mismo patrón que los listados de la Memoria.
//
// Es el único endpoint que el frontend consulta EN LOOP, así que el poller
// (`context/PendingWorkContext.js`) es quien decide la cadencia; acá sólo vive el request.
export const PendingWorkApi = {
    getPendingWork() {
        return new APIClient(API_URL + 'agent/pending-work/').call('GET');
    },
};
